import { X } from 'lucide-react';

import { Progress as BaseProgressBar } from '../progress';
import { Button } from '../button';
import { cn } from '../../lib/utils';

import type { QuizPlayerProgressProps as QuizProgressProps } from './types';

import { QuizPlayerTimer } from './quiz-player-timer';
import { useTranslation } from '@/providers/i18n';

type QuizPlayerProgressProps = React.ComponentProps<'div'> &
  QuizProgressProps & {
    slots?: {
      ProgressBar?: React.ElementType<{ value: number }>;
    };
  };

export function QuizPlayerProgress({
  timeLimit,
  isTimerActive,
  onTimeUp,
  onCancel,
  className,
  slots = {},
  title,
  current = 0,
  total,
  ...others
}: QuizPlayerProgressProps) {
  const { ProgressBar = BaseProgressBar } = slots;
  const { t } = useTranslation();
  const progress = !total ? 0 : (current / total) * 100;
  const stepLabel = !total
    ? null
    : t('quizProgress', {
        args: { value: current, total },
        fallback: `Domanda {value} di {total}`,
      });

  return (
    <div
      data-slot="quiz-player-progress"
      className={cn('w-full text-muted-foreground', className)}
      {...others}
    >
      <div className={`mb-2 font-semibold`}>{title}</div>
      <div className="flex mb-2 gap-2 items-center">
        <span className={`grow text-sm`}>{stepLabel}</span>
        {timeLimit && (
          <QuizPlayerTimer
            timeLimit={timeLimit}
            isActive={isTimerActive ?? true}
            onTimeUp={onTimeUp}
          />
        )}
        <Button size="sm" variant="ghost" onClick={onCancel}>
          <X />
        </Button>
      </div>
      <ProgressBar value={progress} />
    </div>
  );
}
